/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type NotFound = {
    readonly items: ReadonlyArray<{
        readonly title: string | null;
        readonly subtitle: string | null;
        readonly text: string | null;
        readonly errorCode: string;
        readonly button: ReadonlyArray<{
            readonly name: string;
            readonly url: string;
            readonly target: string | null;
        } | null> | null;
    } | null> | null;
    readonly " $refType": "NotFound";
};
export type NotFound$data = NotFound;
export type NotFound$key = {
    readonly " $data"?: NotFound$data;
    readonly " $fragmentRefs": FragmentRefs<"NotFound">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NotFound",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ErrorPagePublishedContent",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "subtitle",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "text",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "errorCode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Link",
          "kind": "LinkedField",
          "name": "button",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "target",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ErrorPagePublishedContentConnection",
  "abstractKey": null
};
(node as any).hash = '14f23ea165d899b97d295b3b4b26d563';
export default node;
